<template>
    <div>
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ title }}</span>
            <span class="create__step">{{ $lang("addPage.step") }} {{ step }}/3</span>
        </div>
        <form-page
            v-bind="wrapProps.values"
            :pageType="1"
            :qrHidden="!!wrapProps.values.utmPromo"
            :title.sync="title"
        >
        </form-page>
    </div>
</template>

<script>
import { mapState } from "vuex";
import FormPage from "./formPage";
import Vue from "vue";

const _ = require("lodash");

export default {
    name: "pay",
    components: { FormPage },
    props: {
        price: {
            default: null
        },
        paymentType: {
            default: null
        },
        master: {
            default: null
        },
        responsible: {
            default: null
        },
        partner: {
            default: null
        },
        burial: {
            default: null
        },
        burial_id: {
            default: null
        },
        copyright: {
            default: false
        },
        notRedirect: {
            default: false
        },
        utmPromo: {
            default: null
        }
    },
    data() {
        return {
            title: Vue.prototype.$lang("addPage.title"),
            wrapProps: {
                values: _.clone(this.$props),
                types: {
                    price: "float",
                    paymentType: "number",
                    master: "number",
                    responsible: "number",
                    partner: "number",
                    burial: "boolean",
                    burial_id: "number",
                    copyright: "boolean",
                    notRedirect: "boolean",
                    utmPromo: "string"
                }
            }
        };
    },
    created() {
        this.loadUrlParamsToProps();
    },
    mounted() {
        const price = this.wrapProps.values.price;

        if (price === null || !this.wrapProps.values.paymentType) {
            let isPartnerBlank = this.$route.query.isPartnerBlank;

            if (isPartnerBlank) {
                return (window.location.href = this.$router.resolve({
                    name: "show-page",
                    params: { slug: this.$route.query.slug }
                }).href);
            } else {
                let prefix = window.laravel.prefix;

                return (window.location.href = prefix.length
                    ? prefix
                    : this.$router.resolve({ name: "home" }).href);
            }
        }

        if (this.copyright) {
            this.$dataLayer.push({ event: "createPagePopup", title: "РаК" });
        } else {
            this.$dataLayer.push({ event: "createPagePopup", title: "Ра" });
        }
    },
    computed: {
        ...mapState("create", ["step"])
    },
    methods: {
        loadUrlParamsToProps() {
            let urlParams = new URLSearchParams(window.location.search);

            for (let prop in this.wrapProps.values) {
                let val = urlParams.get(_.snakeCase(prop));

                if (val === null) {
                    continue;
                }

                val = this.convertToType(val, this.wrapProps.types[prop]);
                if (val === null) {
                    continue;
                }

                this.$set(this.wrapProps.values, prop, val);
            }
        },
        convertToType(value, type) {
            let currentValue = null;

            switch (type) {
                case "string": {
                    currentValue = String(value);
                    break;
                }
                case "number": {
                    if (!Object.is(NaN, parseInt(value))) {
                        currentValue = parseInt(value);
                    }
                    break;
                }
                case "float": {
                    if (!Object.is(NaN, parseFloat(value))) {
                        currentValue = parseFloat(value);
                    }
                    break;
                }
                case "boolean": {
                    currentValue = value === "true";
                    break;
                }
                default: {
                    currentValue = null;
                }
            }

            return currentValue;
        }
    }
};
</script>
